/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box, Card, IconButton, List, ListItem } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "../../Typography/Typography";
import styles from "./style";

// eslint-disable-next-line no-unused-vars
function PermissionModal({ roles, onClose }) {
  //   if (!selectedRole || !selectedRole.length) {
  //     return null;
  //   }
  console.log("Permissions2 :", roles);

  return (
    <Box style={styles.popUp}>
      <Box style={{ display: "flex" }}>
        <Typography variant="title2" color="#8c8c8c">
          Permissions for {roles.name}
        </Typography>
        <div
          style={{
            position: "relative",
            float: "right",
            top: "-8px",
            marginLeft: "auto",
          }}
        >
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </div>
      </Box>
      <Box
        style={{
          boxShadow: "6px 6px 10px #0000001A",
        }}
      >
        <Card elevation={3}>
          <List style={styles.container}>
            {roles?.permissions?.map((value) => {
              return (
                <ListItem style={styles.listItem}>
                  <Box style={styles.remarkText}>
                    <Typography
                      style={{ lineHeight: "16px", paddingTop: "1rem" }}
                      component="p"
                      variant="mini"
                      color="#000000"
                    >
                      {value}
                    </Typography>
                  </Box>
                </ListItem>
              );
            })}
          </List>
        </Card>
      </Box>
    </Box>
  );
}

export default PermissionModal;
